export const host = 'https://content.orionstereo.org'
